/*!
 * abc-a11y-retest-fixes.js
 * American Bench Craft – accessibility add-on for the 13-Oct-2026 retest
 * Fixes the items still Partially Fixed / Not Fixed after the retest:
 *   A11Y-006  Escape in the search dialog returns focus to the Search button
 *   A11Y-040  Product image zoom reachable by keyboard + PhotoSwipe focus return
 *   A11Y-070  Video transcripts: no visible TODO text, correct video titles,
 *             real transcript can be dropped in from the article body
 *   A11Y-076  Policy pages: bold section titles become real <h2> headings
 *   A11Y-096  Price slider no longer reloads the page on every key press;
 *             changes wait for "Apply filters" (keyboard + mouse)
 *   A11Y-114  Predictive search: one listbox, groups, every visible result
 *             (suggestions, collections, products) reachable with arrow keys
 *   NEW       Junip review modal fields get accessible names
 *   v2 (14-Oct-2026, cart drawer retest):
 *   A11Y-042/104  Keyboard Add to cart: one add (duplicate handlers removed),
 *                 failed adds reported in a focused role="alert"
 *   A11Y-106      Redo CHECKOUT+ reachable by Tab inside the drawer trap;
 *                 focus kept in the open drawer; unnamed image links hidden;
 *                 decorative SVGs hidden; upsell "X" is a named button
 *   v3 (15-Oct-2026): descriptive inline form errors replace browser bubbles
 *   v4 (15-Oct-2026): cart drawer reads "Original price / Sale price";
 *                     "added to cart" announced inside the modal drawer
 *   v5 (15-Oct-2026): PDP option groups named (Leather Color / Buckle Hardware
 *                     Color); collection swatches are a radio group with checked state
 *   v6 (video Pause/Play) removed at the client's request
 *   v7 (CSS only): menu dropdown chevrons next to their text
 *   v8 (15-Oct-2026): product carousels select the slide that holds keyboard focus
 *   v9 (15-Oct-2026): star ratings announce the average score
 *   v10 (15-Oct-2026): header cart button says "1 item" (not "1 items")
 *   v11 (15-Oct-2026): mobile menu +/- toggles named "<menu> submenu"
 *   v12 (CSS only): links in policy pages are underlined
 *   v13 (16-Oct-2026): Enter in a product personalization text field adds to cart again
 *
 * Load AFTER ada-pro.js and ada-pro-remain.js (see install notes).
 * Kill switch: add ?a11y=off to the URL or localStorage abcA11yOff = "1".
 * No requestAnimationFrame is used, so it also runs in background tabs.
 */
(function ($) {
  'use strict';
  if (!$ || window.__abcRetestFixes) return;
  window.__abcRetestFixes = true;
  try {
    if (/[?&]a11y=off\b/.test(location.search) || localStorage.getItem('abcA11yOff') === '1') return;
  } catch (e) {}

  // Run after the theme and ada-pro*.js have finished their own DOM-ready work
  // (this file is loaded with defer after them), exactly as it was tested.
  $(function () { setTimeout(main, 0); });

  function main() {

  /* ---------- helpers ---------- */
  function setAttr(el, name, value) {
    if (el && el.getAttribute(name) !== String(value)) el.setAttribute(name, value);
  }
  function rmAttr(el, name) {
    if (el && el.hasAttribute(name)) el.removeAttribute(name);
  }
  function visible(el) {
    return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  }
  /* MutationObserver with debounce + loop breaker (max 30 runs / second) */
  function watch(target, opts, fn, delay) {
    if (!target) return null;
    var t = null, runs = 0, start = 0, paused = false;
    function run() {
      t = null;
      if (paused) return;
      var now = Date.now();
      if (now - start > 1000) { start = now; runs = 0; }
      if (++runs > 30) { paused = true; setTimeout(function () { paused = false; }, 2000); return; }
      fn();
    }
    var mo = new MutationObserver(function () {
      if (!t) t = setTimeout(run, delay || 60);
    });
    mo.observe(target, opts);
    return { schedule: function () { if (!t) t = setTimeout(run, delay || 60); } };
  }
  var $live = null;
  function say(msg) {
    if (!$live) {
      $live = $('<div id="abc-retest-status" class="visually-hidden" role="status" aria-live="polite" aria-atomic="true"></div>').appendTo('body');
    }
    $live.text('');
    setTimeout(function () { $live.text(msg); }, 100);
  }

  /* =====================================================================
   * A11Y-006  Search dialog – Escape returns focus to the Search button
   * ===================================================================== */
  (function () {
    var container = document.querySelector('.site-header__search-container');
    if (!container) return;
    var lastTrigger = null;

    $(document).on('click.abc006 keydown.abc006', '.js-search-header', function () {
      lastTrigger = this;
    });

    function trigger() {
      if (lastTrigger && visible(lastTrigger)) return lastTrigger;
      return $('.js-search-header').filter(function () { return visible(this); }).get(0) || null;
    }

    // keep aria-expanded on the visible Search buttons in sync with the dialog
    function syncExpanded() {
      var open = container.classList.contains('is-active');
      $('.js-search-header').each(function () { setAttr(this, 'aria-expanded', open ? 'true' : 'false'); });
    }
    watch(container, { attributes: true, attributeFilter: ['class'] }, syncExpanded, 20);
    syncExpanded();

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (!container.classList.contains('is-active')) return;
      var btn = trigger();
      var tries = 0;
      (function waitClosed() {
        if (!container.classList.contains('is-active') || tries > 20) {
          // the theme drops focus on <body>; put it back on the trigger
          if (btn && (document.activeElement === document.body || !document.activeElement || container.contains(document.activeElement))) {
            btn.focus();
          }
          return;
        }
        tries++;
        setTimeout(waitClosed, 50);
      })();
    }, true);
  })();

  /* =====================================================================
   * A11Y-040  Product image zoom – keyboard + screen reader access
   * Theme ships the zoom button as an invisible full-image overlay with
   * aria-hidden="true" tabindex="-1". Expose it on the selected slide only.
   * ===================================================================== */
  (function () {
    var slides = document.querySelectorAll('.product-main-slide');
    if (!slides.length) return;
    var lastZoom = null;

    function sync() {
      $('.product__photo-zoom').each(function () {
        var slide = this.closest('.product-main-slide');
        var active = slide ? (slide.classList.contains('is-selected') && slide.getAttribute('aria-hidden') !== 'true') : true;
        if (active) {
          rmAttr(this, 'aria-hidden');
          setAttr(this, 'tabindex', '0');
        } else {
          setAttr(this, 'aria-hidden', 'true');
          setAttr(this, 'tabindex', '-1');
        }
      });
    }
    var host = slides[0].parentElement;
    watch(host, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-hidden'] }, sync, 50);
    sync();
    setTimeout(sync, 1000);
    $(window).on('load.abc040', sync);

    // capture phase: the theme stops propagation of the zoom click
    ['focusin', 'click'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var z = e.target.closest && e.target.closest('.product__photo-zoom');
        if (z) lastZoom = z;
      }, true);
    });
    $(document).on('keydown.abc040', '.product__photo-zoom', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); this.click(); }
    });

    // PhotoSwipe dialog: name it, mark it modal, return focus when it closes
    var pswp = document.querySelector('.pswp');
    if (!pswp) return;
    setAttr(pswp, 'aria-modal', 'true');
    setAttr(pswp, 'aria-label', 'Product image zoom');
    $(pswp).find('.pswp__button--arrow--left').each(function () { setAttr(this, 'aria-label', 'Previous image'); });
    $(pswp).find('.pswp__button--arrow--right').each(function () { setAttr(this, 'aria-label', 'Next image'); });
    $(pswp).find('.pswp__button--close').each(function () { setAttr(this, 'aria-label', 'Close image zoom'); });
    // keep Tab inside the open viewer (it otherwise escapes to the page/iframes)
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !pswp.classList.contains('pswp--open')) return;
      var f = $(pswp).find('button').filter(function () { return visible(this); }).get();
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      e.preventDefault();
      var n = e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i < 0 || i === f.length - 1 ? 0 : i + 1);
      f[n].focus();
    }, true);
    var wasOpen = false;
    watch(pswp, { attributes: true, attributeFilter: ['class'] }, function () {
      var open = pswp.classList.contains('pswp--open');
      if (wasOpen && !open && lastZoom) {
        setTimeout(function () { sync(); if (visible(lastZoom.parentElement)) lastZoom.focus(); }, 50);
      }
      wasOpen = open;
    }, 30);
  })();

  /* =====================================================================
   * A11Y-070  Blog video transcripts
   *  - iframe title is taken from the transcript summary (the real YouTube
   *    title) so the two match
   *  - the "[TODO …]" placeholder is removed (never shown to users)
   *  - a real transcript can be added in the article body:
   *      <div class="abc-transcript-source" data-video-id="UqM7OuF58us" hidden>
   *        <p>Full transcript …</p>
   *      </div>
   *    and is moved into the matching Transcript disclosure.
   * ===================================================================== */
  (function () {
    function run() {
      $('details.a11y-transcript').each(function () {
        var $d = $(this);
        var iframe = $d.prev('iframe')[0] || $d.parent().find('iframe[src*="youtube.com/embed/"]')[0];
        var id = iframe ? (iframe.src.match(/embed\/([^?&/]+)/) || [])[1] : null;
        var summaryText = $.trim($d.children('summary').text()).replace(/^Transcript:\s*/i, '');
        if (iframe && summaryText) setAttr(iframe, 'title', summaryText);

        $d.find('.a11y-transcript__todo').remove();

        if (id && !$d.find('.abc-transcript-body').length) {
          var $src = $('.abc-transcript-source[data-video-id="' + id + '"]').first();
          if ($src.length) {
            $('<div class="abc-transcript-body"></div>').append($src.contents()).appendTo($d);
            $src.remove();
          }
        }
      });
    }
    run();
    setTimeout(run, 800);
    setTimeout(run, 2500);
    // the transcript <details> are created late by ada-pro-remain.js, so also
    // run whenever article content changes (run() is idempotent)
    if (document.querySelector('iframe[src*="youtube.com/embed/"]')) {
      watch(document.querySelector('.article, article, main') || document.body, { childList: true, subtree: true }, run, 200);
    }
  })();

  /* =====================================================================
   * A11Y-076  Policy pages – bold section titles become <h2> headings
   * Pattern: <p><strong>SECTION 1 - ACCESS AND ACCOUNT</strong><br>text…</p>
   * ===================================================================== */
  (function () {
    if (!/^\/policies\//.test(location.pathname)) return;
    var body = document.querySelector('.shopify-policy__body');
    if (!body || body.querySelector('h2.abc-policy-heading')) return;

    function isBlank(node) {
      return node && ((node.nodeType === 3 && !node.textContent.trim()) ||
        (node.nodeType === 1 && node.tagName === 'STRONG' && !node.textContent.trim()));
    }
    function isBreak(node) { return node && node.nodeName === 'BR'; }
    function trimEdge(el, fromStart) {
      var n = fromStart ? el.firstChild : el.lastChild;
      while (n && (isBreak(n) || isBlank(n))) {
        el.removeChild(n);
        n = fromStart ? el.firstChild : el.lastChild;
      }
    }
    $(body).find('p > strong').each(function () {
      var strong = this, p = strong.parentNode;
      var text = $.trim(strong.textContent);
      if (!text || text.length > 120) return;
      if (text !== text.toUpperCase() || !/[A-Z]/.test(text)) return; // section titles are ALL CAPS
      // title must start a line: preceded by nothing or a <br>
      var prev = strong.previousSibling;
      while (prev && isBlank(prev)) prev = prev.previousSibling;
      if (prev && !isBreak(prev)) return;
      // …and end a line: followed by a <br> or nothing
      var next = strong.nextSibling;
      while (next && isBlank(next)) next = next.nextSibling;
      if (next && !isBreak(next)) return;

      // text before the title (end of the previous section) keeps its own <p>
      var before = document.createElement('p');
      while (p.firstChild && p.firstChild !== strong) before.appendChild(p.firstChild);
      trimEdge(before, false);
      if (before.textContent.trim() || before.querySelector('img,a')) p.parentNode.insertBefore(before, p);

      var h = document.createElement('h2');
      h.className = 'abc-policy-heading';
      h.textContent = text;
      p.parentNode.insertBefore(h, p);

      p.removeChild(strong);
      trimEdge(p, true);
      if (!p.textContent.trim() && !p.querySelector('img,a')) p.parentNode.removeChild(p);
    });
  })();

  /* =====================================================================
   * A11Y-096  Price slider – changes wait for "Apply filters"
   * Replaces the 1.5 s auto-commit (ada-pro.js A11Y-096) and the theme's
   * immediate AJAX render on mouse drag.
   * ===================================================================== */
  (function () {
    var drawer = document.getElementById('FilterDrawer');
    if (!drawer) return;
    var pricePending = false;

    function money(v) {
      v = parseFloat(v);
      return '$' + (isNaN(v) ? '0.00' : v.toFixed(2));
    }
    function writeInputs(target, vals) {
      var form = target.closest('form');
      if (!form) return;
      var min = form.querySelector('input[name="filter.v.price.gte"]');
      var max = form.querySelector('input[name="filter.v.price.lte"]');
      if (min) min.value = vals[0];
      if (max) max.value = vals[1];
    }
    function markPending(target) {
      var vals = [].concat(target.noUiSlider.get()).map(parseFloat);
      writeInputs(target, vals);
      pricePending = true;
      say('Price ' + money(vals[0]) + ' to ' + money(vals[1]) + '. Press Apply filters to update the products.');
    }

    // mouse / touch: stop the theme's immediate AJAX render on "change"
    function rebindSliders() {
      drawer.querySelectorAll('.price-range__slider').forEach(function (el) {
        var s = el.noUiSlider;
        if (!s || el.__abc096) return;
        el.__abc096 = true;
        s.off('change');
        s.on('change.abc096', function () { markPending(el); });
      });
    }
    rebindSliders();
    setTimeout(rebindSliders, 1000);
    document.addEventListener('collection:reloaded', function () { setTimeout(rebindSliders, 50); });

    // keyboard: runs before ada-pro.js (document capture) and the theme
    window.addEventListener('keydown', function (e) {
      var h = e.target;
      if (!h || !h.classList || !h.classList.contains('noUi-handle') || !h.closest('#FilterDrawer')) return;
      var target = h.closest('.noUi-target');
      var s = target && target.noUiSlider;
      if (!s) return;
      var steps = { ArrowLeft: -1, ArrowDown: -1, ArrowRight: 1, ArrowUp: 1, PageDown: -5, PageUp: 5 };
      if (e.key in steps) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var step = (s.options && s.options.step) || 1;
        var idx = +h.getAttribute('data-handle');
        var vals = [].concat(s.get()).map(parseFloat);
        var set = [null, null];
        set[idx] = vals[idx] + steps[e.key] * step;
        s.set(set, false); // false = do not fire "change"
        markPending(target);
      } else if (e.key === 'Home' || e.key === 'End') {
        e.preventDefault();
        e.stopImmediatePropagation();
        var r = s.options.range, set2 = [null, null];
        set2[+h.getAttribute('data-handle')] = e.key === 'Home' ? r.min : r.max;
        s.set(set2, false);
        markPending(target);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        e.stopImmediatePropagation();
        commit(h);
      }
    }, true);

    function commit(from) {
      var form = (from && from.closest('form')) || drawer.querySelector('form.filter-form, form');
      if (!form) return;
      var p = new URLSearchParams(new FormData(form));
      var cur = new URLSearchParams(location.search);
      if (cur.get('sort_by')) p.set('sort_by', cur.get('sort_by'));
      p.delete('page');
      // drop empty / full-range price params so the URL stays clean
      ['filter.v.price.gte', 'filter.v.price.lte'].forEach(function (k) { if (p.get(k) === '') p.delete(k); });
      try {
        var h = drawer.querySelector('.noUi-handle:focus') || drawer.querySelector('.noUi-handle');
        sessionStorage.setItem('a11y096Handle', h ? h.getAttribute('data-handle') : '0'); // ada-pro.js reopens drawer + focuses handle
        sessionStorage.setItem('a11y098Pending', '1');                                      // ada-pro.js announces the results
      } catch (err) {}
      location.search = p.toString();
    }

    // "Apply filters" applies a pending price change (runs before ada-pro.js)
    window.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.a11y-filter-apply .btn');
      if (!btn || !pricePending) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      pricePending = false;
      say('Applying filters…');
      commit(btn);
    }, true);
  })();

  /* =====================================================================
   * A11Y-114  Predictive search – valid combobox / listbox
   *  #predictive-search-results  role=listbox (single)
   *    .results                  role=group  aria-labelledby=<h3>
   *      ul / li                 role=none
   *        a                     role=option (all visible results)
   *  Arrow keys / Home / End / Enter handled here (window capture) so the
   *  older handlers in ada-pro.js and ada-pro-remain.js do not compete.
   * ===================================================================== */
  (function () {
    var input = document.getElementById('Search');
    if (!input) return;
    // #predictive-search-results is created on the first search and replaced
    // on every render, so always look it up again instead of keeping a reference
    function wrap() { return document.getElementById('predictive-search-results'); }
    var host = input.closest('[role="dialog"], .site-header__search') || document.body;
    var idx = -1;

    function options() {
      return $(wrap()).find('a[href]').filter(function () { return visible(this); });
    }
    function normalize() {
      var w = wrap();
      if (!w) return;
      setAttr(w, 'role', 'listbox');
      setAttr(w, 'aria-label', 'Search suggestions');
      $(w).find('.results').each(function (gi) {
        var h = this.querySelector('h3, h2, .h4');
        if (!visible(this)) {
          // hidden duplicate groups must not expose options
          setAttr(this, 'aria-hidden', 'true');
          $(this).find('[role]').each(function () { rmAttr(this, 'role'); });
          $(this).find('a').each(function () { setAttr(this, 'tabindex', '-1'); rmAttr(this, 'aria-selected'); });
          return;
        }
        rmAttr(this, 'aria-hidden');
        setAttr(this, 'role', 'group');
        if (h) {
          if (!h.id || document.querySelectorAll('#' + CSS.escape(h.id)).length > 1) h.id = 'abc-ps-group-' + gi;
          setAttr(this, 'aria-labelledby', h.id);
          setAttr(h, 'aria-hidden', 'true'); // group name comes via aria-labelledby
        }
      });
      $(w).find('ul, li').each(function () { setAttr(this, 'role', 'none'); rmAttr(this, 'aria-selected'); });
      var $o = options(), setsize = String($o.length);
      $o.each(function (i) {
        setAttr(this, 'role', 'option');
        setAttr(this, 'id', 'abc-ps-opt-' + i);
        setAttr(this, 'tabindex', '-1');
        setAttr(this, 'aria-selected', i === idx ? 'true' : 'false');
        setAttr(this, 'aria-setsize', setsize);
        setAttr(this, 'aria-posinset', String(i + 1));
      });
      if (input.getAttribute('aria-controls') !== 'predictive-search-results') setAttr(input, 'aria-controls', 'predictive-search-results');
    }
    function activate(i) {
      normalize();
      var $o = options();
      if (!$o.length) return;
      idx = (i + $o.length) % $o.length;
      $o.removeClass('a11y-active abc-ps-active').attr('aria-selected', 'false');
      var el = $o.eq(idx).addClass('abc-ps-active').attr('aria-selected', 'true')[0];
      setAttr(input, 'aria-activedescendant', el.id);
      el.scrollIntoView({ block: 'nearest' });
    }
    function reset() {
      idx = -1;
      rmAttr(input, 'aria-activedescendant');
      $(wrap()).find('.abc-ps-active').removeClass('abc-ps-active').attr('aria-selected', 'false');
    }

    watch(host, { childList: true, subtree: true }, function () { if (idx < 0) normalize(); }, 80);
    input.addEventListener('input', function () { reset(); setTimeout(normalize, 400); setTimeout(normalize, 1200); });

    window.addEventListener('keydown', function (e) {
      if (e.target !== input) return;
      var w = wrap();
      if (!w || !visible(w) || !options().length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); e.stopImmediatePropagation(); activate(idx + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); e.stopImmediatePropagation(); activate(idx < 0 ? -1 : idx - 1); }
      else if (e.key === 'Enter' && idx > -1) {
        e.preventDefault(); e.stopImmediatePropagation();
        var el = options().get(idx);
        if (el) window.location.href = el.href;
      }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Home' || e.key === 'End') {
        reset(); // caret goes back to the text field (APG combobox pattern)
      }
    }, true);
  })();

  /* =====================================================================
   * NEW  Junip "Write a review" modal – fields without an accessible name
   * ===================================================================== */
  (function () {
    function nameFields(root) {
      $(root).find('.junip-modal textarea, .junip-modal input:not([type=hidden])').each(function () {
        if (this.getAttribute('aria-label') || this.getAttribute('aria-labelledby') || (this.labels && this.labels.length)) return;
        var ph = $.trim(this.getAttribute('placeholder') || '');
        var name = this.tagName === 'TEXTAREA' ? 'Your review' : (ph || this.name || '').replace(/\.{3}|…/g, '');
        if (name) setAttr(this, 'aria-label', name);
      });
    }
    watch(document.body, { childList: true, subtree: true }, function () {
      if (document.querySelector('.junip-modal')) nameFields(document);
    }, 150);
    // Junip swaps steps without always adding nodes: also name a field the
    // moment it receives focus (before assistive technology reads it)
    document.addEventListener('focusin', function (e) {
      var m = e.target.closest && e.target.closest('.junip-modal');
      if (m) nameFields(m.parentNode);
    }, true);
  })();


  /* =====================================================================
   * v2 – 14-Oct-2026 retest (cart drawer now testable)
   * ===================================================================== */

  /* A11Y-042 / 104  Keyboard "Add to cart" added the item TWICE
   * Root cause: ada-pro.js (A11Y-135) and the older ada-pro-remain.js (abc135)
   * both bind keydown Enter/Space -> trigger('click') on the button, so one key
   * press fired two clicks / two submits. Both also bind an 8-second "fallback"
   * that re-posts /cart/add.js when the cart count has not changed - it races
   * upez's own add and posts a second item. The native <button> already
   * handles Enter/Space, so remove those handlers and let upez do the single
   * add. Errors are still reported: when upez's add request fails (e.g. 422),
   * the spinner is cleared and the message is shown in a role="alert" and
   * focused (upez otherwise spins forever).                              */
  (function () {
    var $btn = $('form[action*="/cart/add"] .with-upez-loader');
    if (!$btn.length || !document.getElementById('upezCartContainer')) return;
    function unbind() { $btn.off('.abc135').off('.a11y135'); }
    unbind();
    $(window).on('load.abc042', unbind); // in case they bind after us

    var $status = $('#a11y-atc-status');
    if (!$status.length) $status = $('<div id="a11y-atc-status" role="alert" class="visually-hidden"></div>').insertAfter($btn.first());
    function showError(msg) {
      $btn.each(function () { this.removeAttribute('adding'); this.disabled = false; rmAttr(this, 'aria-busy'); });
      $status.removeClass('visually-hidden').addClass('form-message form-message--error')
        .text(msg || 'Sorry, this item could not be added to the cart. Please try again.');
      setAttr($status[0], 'tabindex', '-1');
      $status[0].focus();
    }
    $btn.on('click.abc042', function () {
      $status.text('').addClass('visually-hidden').removeClass('form-message form-message--error');
    });
    if (window.fetch && !window.fetch.__abc042) {
      var orig = window.fetch;
      var wrapped = function (input) {
        var url = String((input && input.url) || input || '');
        var p = orig.apply(this, arguments);
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
          p.then(function (res) {
            if (res && !res.ok) {
              res.clone().json().catch(function () { return {}; }).then(function (j) {
                showError(j && (j.description || j.message));
              });
            }
          }, function () { showError(); });
        }
        return p;
      };
      wrapped.__abc042 = true;
      window.fetch = wrapped;
    }
  })();

  /* A11Y-106 + cart drawer clean-up
   *  - Redo "Checkout+" (<redo-shopify-toggle>, closed shadow DOM + iframe)
   *    holds the visible CHECKOUT+ button. The drawer focus trap (ada-pro.js
   *    A11Y-010) treated the host as the last stop and wrapped to "Close cart",
   *    so checkout could not be reached by keyboard. Let Tab move natively
   *    inside custom elements and catch focus when it leaves the drawer.
   *  - Product image links duplicate the title link and had no name: hide
   *    them from AT and the tab order.
   *  - Decorative SVGs outside controls: aria-hidden.
   *  - "Hide recommendations" X on the upsell was a mouse-only <div>.     */
  (function () {
    var SEL = '[role="dialog"][aria-label="Shopping cart"]';
    function drawer() { return document.querySelector(SEL); }
    function isOpen(d) {
      if (!d || !d.getClientRects().length) return false;
      var r = d.getBoundingClientRect();
      return r.width > 0 && r.left < window.innerWidth - 10 && r.right > 10;
    }
    function firstStop(d) {
      return d.querySelector('[aria-label="Close cart"]') ||
        $(d).find('a[href],button,[tabindex="0"]').filter(function () { return visible(this); }).get(0);
    }

    // 1. Tab passes through custom elements (Redo) instead of being wrapped
    window.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var d = drawer(), a = document.activeElement;
      if (!isOpen(d) || !a || !d.contains(a)) return;
      if (a.tagName.indexOf('-') > 0) e.stopImmediatePropagation(); // skip ada-pro A11Y-010 wrap
    }, true);

    // 2. focus leaving the open drawer goes back to its first control
    function guard() {
      var d = drawer(), a = document.activeElement;
      if (!isOpen(d) || !a || a === document.body || d.contains(a)) return;
      if (a.closest && a.closest('.pswp, .junip-modal, #upezCartContainer')) return;
      var f = firstStop(d);
      if (f) f.focus();
    }
    document.addEventListener('focusin', function () { setTimeout(guard, 0); }, true);
    window.addEventListener('blur', function () { setTimeout(guard, 0); }); // focus moved into an <iframe>

    // 3–5. names / hidden decoration / dismiss button (attribute-only writes)
    function fix() {
      var d = drawer();
      if (!d) return;
      $(d).find('a[href]').each(function () {
        if ($.trim(this.textContent) || this.getAttribute('aria-label')) return;
        var href = this.getAttribute('href');
        var twin = $(d).find('a[href]').filter(function () {
          return this.getAttribute('href') === href && $.trim(this.textContent);
        }).length;
        if (twin) {
          setAttr(this, 'aria-hidden', 'true');
          setAttr(this, 'tabindex', '-1');
        } else {
          var alt = $.trim($(this).find('img[alt]').attr('alt') || '');
          if (alt) setAttr(this, 'aria-label', alt);
        }
      });
      $(d).find('svg').each(function () {
        if (this.closest('[role="img"], button, a, [role="button"]')) return;
        if (this.getAttribute('aria-label') || this.querySelector('title')) return;
        setAttr(this, 'aria-hidden', 'true');
        setAttr(this, 'focusable', 'false');
      });
      $(d).find('.builder-block').each(function () {
        if (this.hasAttribute('data-abc-dismiss') || this.getAttribute('role')) return;
        if ($.trim(this.textContent) || !this.querySelector('svg')) return;
        if (this.querySelector('.builder-block')) return; // innermost block = the one with the click handler
        if (this.closest('a, button, [role="button"]') || getComputedStyle(this).cursor !== 'pointer') return;
        var scope = this.parentElement && this.parentElement.parentElement;
        if (!scope || !/you may also like/i.test(scope.textContent)) return;
        setAttr(this, 'data-abc-dismiss', '1');
        setAttr(this, 'role', 'button');
        setAttr(this, 'tabindex', '0');
        setAttr(this, 'aria-label', 'Hide product recommendations');
        $(this).on('keydown.abcDismiss', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            this.click();
            // the recommendations block (and this button) is removed: keep focus in the drawer
            // (Builder re-renders the drawer, so look it up again)
            [300, 1000].forEach(function (ms) {
              setTimeout(function () {
                var dd = drawer(), a = document.activeElement;
                if (dd && (!a || a === document.body || !dd.contains(a))) { var f = firstStop(dd); if (f) f.focus(); }
              }, ms);
            });
          }
        });
      });
    }
    var root = document.getElementById('upezCartContainer') || document.body;
    watch(root, { childList: true, subtree: true }, fix, 120);
    fix();
  })();

  /* =====================================================================
   * v3 – 15-Oct-2026  DESCRIPTIVE FORM ERRORS (WCAG 3.3.1, 3.3.3, 4.1.2)
   * Forms that rely on the browser's built-in validation (e.g. the required
   * "Dog name" / "Line 1" personalization fields on every product page)
   * showed only the generic browser bubble "Please fill in this field." -
   * it disappears after a few seconds, is not linked to the field, and does
   * not say what to enter.
   * Fix: cancel the bubble on the 'invalid' event and show a persistent,
   * specific inline message under the field, linked with aria-describedby,
   * with aria-invalid="true"; focus moves to the first invalid field.
   * The message updates while typing and is removed once the field is valid.
   * Forms that already use their own validation (novalidate: contact,
   * register, newsletter) are not affected. Any field can override the
   * wording with data-error-message="...".
   * ===================================================================== */
  (function () {
    var seq = 0, pending = [], timer = null;

    // Specific wording for known fields (matched against the field name)
    var KNOWN = [
      [/^dog name/i, function (max) { return "Enter your dog's name for the name plate" + (max ? ' (up to ' + max + ' characters)' : '') + '. This field is required.'; }],
      [/engraving|plate text|^line 1$/i, function (max) { return 'Enter the text to engrave on the first line' + (max ? ' (up to ' + max + ' characters)' : '') + '. This field is required.'; }],
      [/initial|monogram/i, function (max) { return 'Enter the initials to emboss' + (max ? ' (up to ' + max + ' characters)' : '') + '. This field is required.'; }]
    ];

    function cleanName(t) {
      return $.trim(String(t || '')
        .replace(/\s+/g, ' ')
        .replace(/\b\d+\s*\|\s*\d+\b/g, '')                     // character counter "0 | 24"
        .replace(/\((?:up to\s*)?\d+\s*characters?\)/ig, '')    // "(24 Characters)"
        .replace(/\(required\)/ig, '')
        .replace(/\*/g, '')
        .replace(/\s+/g, ' '))
        .replace(/[\s:.,\-]+$/, '');
    }
    function fieldName(el) {
      var t = '';
      if (el.getAttribute('aria-labelledby')) {
        t = el.getAttribute('aria-labelledby').split(/\s+/).map(function (id) {
          var n = document.getElementById(id); return n ? n.textContent : '';
        }).join(' ');
      }
      if (!$.trim(t) && el.getAttribute('aria-label')) t = el.getAttribute('aria-label');
      if (!$.trim(t) && el.labels && el.labels.length) t = el.labels[0].textContent;
      if (!$.trim(t) && (el.type === 'radio' || el.type === 'checkbox')) {
        var fs = el.closest('fieldset'), lg = fs && fs.querySelector('legend');
        if (lg) t = lg.textContent;
      }
      if (!$.trim(t)) t = el.getAttribute('placeholder') || el.name || '';
      t = cleanName(t);
      // "Line 2 Phone Number on Line 2" -> keep the useful first part
      return t || 'This field';
    }
    function lc(s) { return s.charAt(0).toLowerCase() + s.slice(1); }

    function message(el) {
      var own = el.getAttribute('data-error-message');
      if (own) return own;
      var v = el.validity, name = fieldName(el), max = el.maxLength > 0 ? el.maxLength : null;
      var len = (el.value || '').length;
      if (v.valueMissing) {
        for (var i = 0; i < KNOWN.length; i++) if (KNOWN[i][0].test(name)) return KNOWN[i][1](max);
        if (el.type === 'checkbox') return 'Check "' + name + '" to continue.';
        if (el.type === 'radio') return 'Select an option for ' + lc(name) + '.';
        if (el.tagName === 'SELECT') return 'Select ' + lc(name) + '. This field is required.';
        if (el.type === 'email') return name + ' is required. Enter your email address, for example name@example.com.';
        if (el.type === 'tel') return name + ' is required. Enter a phone number, for example 555-123-4567.';
        if (el.type === 'file') return 'Choose a file for ' + lc(name) + '.';
        return name + ' is required. Enter ' + lc(name) + (max ? ' (up to ' + max + ' characters)' : '') + '.';
      }
      if (v.typeMismatch && el.type === 'email') return 'Enter a valid email address, for example name@example.com.';
      if (v.typeMismatch && el.type === 'url') return 'Enter a full web address, for example https://www.example.com.';
      if (v.patternMismatch) {
        if (el.title) return el.title;
        if (el.type === 'tel') return 'Enter a phone number using numbers, spaces, dashes or +, for example 555-123-4567.';
        return name + ' is not in the expected format.';
      }
      if (v.tooLong) return name + ' can be up to ' + max + ' characters. Remove ' + (len - max) + ' character' + (len - max === 1 ? '' : 's') + '.';
      if (v.tooShort) return name + ' needs at least ' + el.minLength + ' characters (you entered ' + len + ').';
      if (v.rangeUnderflow) return name + ' must be ' + el.min + ' or more.';
      if (v.rangeOverflow) return name + ' must be ' + el.max + ' or less.';
      if (v.stepMismatch) return 'Enter a valid value for ' + lc(name) + ', for example a whole number.';
      if (v.badInput) return 'Enter a number for ' + lc(name) + '.';
      return el.validationMessage || (name + ' is not valid.');
    }

    function errorFor(el) { return el.__abcErr || null; }
    function anchorFor(el) {
      if (el.type === 'radio' || el.type === 'checkbox') {
        return el.closest('fieldset') || el.closest('label') || el;
      }
      var a = el, n = el.nextElementSibling;
      // put the message after the character counter ("0 | 24") if there is one
      while (n && (/count|counter|limit|char/i.test((n.className || '') + ' ' + (n.id || '')) || /^\s*\d+\s*\|\s*\d+\s*$/.test(n.textContent))) {
        a = n; n = n.nextElementSibling;
      }
      return a;
    }
    function addDesc(el, id) {
      var d = (el.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
      if (d.indexOf(id) === -1) { d.unshift(id); el.setAttribute('aria-describedby', d.join(' ')); }
    }
    function removeDesc(el, id) {
      var d = (el.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (x) { return x && x !== id; });
      if (d.length) el.setAttribute('aria-describedby', d.join(' ')); else el.removeAttribute('aria-describedby');
    }
    function show(el) {
      var msg = message(el), err = errorFor(el);
      if (!err) {
        err = document.createElement('p');
        err.id = 'abc-err-' + (++seq);
        err.className = 'abc-field-error';
        anchorFor(el).insertAdjacentElement('afterend', err);
        el.__abcErr = err;
      }
      err.innerHTML = '<span class="abc-field-error__icon" aria-hidden="true">!</span><span class="abc-field-error__text"></span>';
      err.lastChild.textContent = msg;
      addDesc(el, err.id);
      setAttr(el, 'aria-invalid', 'true');
      el.classList.add('abc-field-invalid');
      // radios: mark the whole group
      if (el.type === 'radio' && el.name && el.form) {
        $(el.form).find('input[type=radio]').filter(function () { return this.name === el.name; }).each(function () {
          addDesc(this, err.id); setAttr(this, 'aria-invalid', 'true');
        });
      }
    }
    function clear(el) {
      var err = errorFor(el);
      if (!err) return;
      var targets = (el.type === 'radio' && el.name && el.form)
        ? $(el.form).find('input[type=radio]').filter(function () { return this.name === el.name; }).get()
        : [el];
      targets.forEach(function (t) { removeDesc(t, err.id); rmAttr(t, 'aria-invalid'); t.classList.remove('abc-field-invalid'); t.__abcErr = null; });
      if (err.parentNode) err.parentNode.removeChild(err);
    }
    function flush() {
      timer = null;
      var list = pending.filter(function (el) { return document.contains(el); });
      pending = [];
      if (!list.length) return;
      list.sort(function (a, b) { return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; });
      var first = list[0];
      // the button that submitted may show a spinner; clear it
      $(first.form || document).find('.with-upez-loader[adding]').each(function () { this.removeAttribute('adding'); });
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
      first.scrollIntoView({ block: 'center' });
      if (list.length > 1) say(list.length + ' fields need attention. ' + message(first));
    }

    document.addEventListener('invalid', function (e) {
      var el = e.target;
      if (!el || !el.matches || !el.matches('input, select, textarea')) return;
      if (!visible(el)) return;                       // hidden fields: leave to the browser
      e.preventDefault();                             // no generic browser bubble
      show(el);
      pending.push(el);
      if (!timer) timer = setTimeout(flush, 0);
    }, true);

    function recheck(e) {
      var el = e.target;
      if (!el || !el.__abcErr) return;
      if (el.validity && el.validity.valid) clear(el);
      else show(el);                                  // keep the message accurate while typing
      if (el.type === 'radio' && el.validity.valid) clear(el);
    }
    document.addEventListener('input', recheck, true);
    document.addEventListener('change', recheck, true);
  })();


  /* =====================================================================
   * v4 – 15-Oct-2026  Cart drawer: prices + "added to cart" announcement
   * ===================================================================== */

  /* Cart drawer line-item prices
   * NVDA read "Price: $35, Price: $25": ada-pro.js (A11Y-046) labels the sale
   * price "Price:", and the label is duplicated in front of the struck-through
   * original price when upez re-renders. Strikethrough (CSS line-through) is not
   * exposed to screen readers, so users could not tell which price was the old
   * one. Label the pair "Original price:" / "Sale price:". The labels keep the
   * a11y046 class so ada-pro does not add another "Price:".           */
  (function () {
    var root = document.getElementById('upezCartContainer');
    if (!root) return;
    function label(el, text) {
      var prev = el.previousElementSibling;
      if (prev && prev.classList.contains('a11y046')) {
        if (prev.textContent !== text + ' ') prev.textContent = text + ' ';
      } else {
        var s = document.createElement('span');
        s.className = 'visually-hidden a11y046 abc-price-label';
        s.textContent = text + ' ';
        el.parentNode.insertBefore(s, el);
      }
    }
    function fix() {
      var olds = root.querySelectorAll('upez-money-convert.upez--cart-item--original-price');
      for (var i = 0; i < olds.length; i++) {
        var o = olds[i], box = o.parentNode;
        var n = box && box.querySelector('upez-money-convert.upez--cart-item--discounted-price');
        if (!n) continue;
        var crossed = visible(o) && o.textContent.trim() !== n.textContent.trim();
        if (crossed) {
          label(o, 'Original price:');
          label(n, 'Sale price:');
        } else {
          // not discounted: hide the duplicate and read one plain price
          var p = o.previousElementSibling;
          if (p && p.classList.contains('a11y046') && p.textContent) p.textContent = '';
          label(n, 'Price:');
        }
      }
    }
    fix();
    watch(root, { childList: true, subtree: true, characterData: true }, fix, 120);
  })();

  /* "Added to cart" was not announced by NVDA
   * ada-pro.js (A11Y-104) writes "X added to cart." into a live region at the
   * end of <body>. upez then opens the cart as role="dialog" aria-modal="true"
   * and moves focus to "Close cart". Chrome removes everything outside an
   * aria-modal dialog from the accessibility tree, so that live region is
   * never heard, and the focus change would interrupt it anyway.
   * Fix: put the message INSIDE the dialog and make it the dialog's
   * aria-describedby, so NVDA reads "Shopping cart, dialog, <item> added to
   * cart ... , Close cart, button" when focus lands. If focus is already in the
   * drawer (adding from "You may also like"), an in-dialog live region is used. */
  (function () {
    var SEL = '[role="dialog"][aria-label="Shopping cart"]';
    if (!document.getElementById('upezCartContainer') || !window.fetch) return;
    var DESC_ID = 'abc-cart-added-desc', LIVE_ID = 'abc-cart-added-live';
    var message = '', expires = 0;

    function money(cents) {
      return '$' + (Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, '');
    }
    function drawer() { return document.querySelector(SEL); }
    function isOpen(d) {
      if (!d || !d.getClientRects().length) return false;
      var r = d.getBoundingClientRect();
      return r.width > 0 && r.left < window.innerWidth - 10 && r.right > 10;
    }
    function ensure(d, id, live) {
      var el = document.getElementById(id);
      if (el && d.contains(el)) return el;
      if (el) el.parentNode.removeChild(el);
      el = document.createElement('div');
      el.id = id;
      el.className = 'visually-hidden';
      if (live) { el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); el.setAttribute('aria-atomic', 'true'); }
      d.insertBefore(el, d.firstChild);
      return el;
    }
    function attach() {
      var d = drawer();
      if (!d) return;
      ensure(d, LIVE_ID, true);               // live region must exist before it changes
      var desc = ensure(d, DESC_ID, false);
      if (message && Date.now() < expires) {
        if (desc.textContent !== message) desc.textContent = message;
        var ids = (d.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        if (ids.indexOf(DESC_ID) < 0) d.setAttribute('aria-describedby', [DESC_ID].concat(ids).join(' '));
      } else {
        if (desc.textContent) desc.textContent = '';
        var rest = (d.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (x) { return x && x !== DESC_ID; });
        if (rest.length) d.setAttribute('aria-describedby', rest.join(' ')); else d.removeAttribute('aria-describedby');
      }
    }
    function announce(msg) {
      var d = drawer();
      message = msg;
      expires = Date.now() + 8000;            // only for the open that follows this add
      if (d && isOpen(d) && d.contains(document.activeElement)) {
        // already inside the drawer: focus will not move, use the in-dialog live region
        var live = ensure(d, LIVE_ID, true);
        live.textContent = '';
        setTimeout(function () { live.textContent = msg; }, 150);
        message = '';
      }
      attach();
    }
    function build(added, cart) {
      var items = (added && added.items) ? added.items : [added];
      var parts = items.filter(Boolean).map(function (it) {
        var name = it.product_title || it.title || 'Item';
        if (it.variant_title && name.indexOf(it.variant_title) < 0) name += ', ' + it.variant_title;
        var line = name + ' added to cart';
        var orig = it.original_price, fin = it.final_price != null ? it.final_price : it.price;
        if (orig && fin != null && fin < orig) line += ', sale price ' + money(fin) + ', original price ' + money(orig);
        else if (fin != null) line += ', ' + money(fin);
        return line + '.';
      });
      if (cart && cart.item_count != null) {
        parts.push('Cart has ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') +
          ', subtotal ' + money(cart.total_price) + '.');
      }
      return parts.join(' ');
    }

    var orig = window.fetch;
    var wrapped = function (input) {
      var url = String((input && input.url) || input || '');
      var p = orig.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(function (added) {
            return orig.call(window, '/cart.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .catch(function () { return null; })
              .then(function (cart) { announce(build(added, cart)); });
          }).catch(function () {});
        }, function () {});
      }
      return p;
    };
    for (var k in orig) { try { wrapped[k] = orig[k]; } catch (e) {} } // keep __abc042 / __a11y104 flags
    window.fetch = wrapped;

    // keep the description in place while upez re-renders; drop it once the drawer closes
    var root = document.getElementById('upezCartContainer');
    watch(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'inert'] }, function () {
      var d = drawer();
      if (message && d && !isOpen(d) && Date.now() > expires) message = '';
      attach();
    }, 60);
    document.addEventListener('focusout', function (e) {
      var d = drawer();
      if (d && d.contains(e.target) && !(e.relatedTarget && d.contains(e.relatedTarget))) {
        setTimeout(function () { if (!isOpen(drawer())) { message = ''; attach(); } }, 400);
      }
    }, true);
  })();


  /* =====================================================================
   * v5 – 15-Oct-2026  Colour / hardware swatches
   * ===================================================================== */

  /* PDP option groups ("Leather Color", "Buckle Hardware Color")
   * The swatches are native radios in a <fieldset>, but its <legend> has the
   * theme class "hide" (display:none), so the group has no name. The visible
   * heading is a <label for="<fieldset id>">, and a fieldset cannot be
   * labelled that way. NVDA therefore read "Premium Brown, radio button" with
   * no hint which option it belongs to. The visible name under each swatch
   * (.color-swatch-label) also duplicated the radio label in browse mode.
   * Fix: expose the legend (visually hidden), hide the duplicate texts.
   * NVDA now reads "Leather Color grouping, Premium Brown, radio button,
   * checked, 1 of 5".                                                  */
  (function () {
    function fix() {
      var sets = document.querySelectorAll('fieldset.variant-input-wrap');
      for (var i = 0; i < sets.length; i++) {
        var fs = sets[i];
        var name = fs.getAttribute('name') || '';
        var legend = fs.querySelector('legend');
        if (!legend) {
          legend = document.createElement('legend');
          fs.insertBefore(legend, fs.firstChild);
        }
        if (legend.classList.contains('hide')) legend.classList.remove('hide');
        if (!legend.classList.contains('visually-hidden')) legend.classList.add('visually-hidden');
        if (!legend.textContent.trim() && name) legend.textContent = name;
        // the visible heading is decorative for AT now (the legend names the group)
        var wrap = fs.closest('.variant-wrapper');
        var head = wrap && wrap.querySelector('label.variant__label[for="' + fs.id + '"]');
        if (head) setAttr(head, 'aria-hidden', 'true');
        // visible caption under each swatch repeats the radio's own label
        var caps = fs.querySelectorAll('.color-swatch-label');
        for (var j = 0; j < caps.length; j++) setAttr(caps[j], 'aria-hidden', 'true');
      }
    }
    fix();
    var form = document.querySelector('form[action*="/cart/add"]');
    watch(form && (form.closest('.product-single__meta, .product-section, main') || form),
      { childList: true, subtree: true }, fix, 150);
  })();

  /* Collection cards: colour swatches
   * ada-pro.js (A11Y-021) made each swatch a toggle button with aria-pressed.
   * Five toggle buttons where pressing one un-presses the others is not how a
   * single choice is announced; NVDA said "toggle button, not pressed" and the
   * chosen colour was easy to miss. It is a single-choice group, so expose it
   * as a radio group: role=radiogroup + role=radio + aria-checked, one Tab stop
   * per card (roving tabindex), Arrow keys move and select, Space/Enter select.
   * NVDA: "Color options for X, radio group, Premium Black, radio button,
   * checked, 2 of 5".                                                   */
  (function () {
    if (!document.querySelector('.grid-product__colors')) return;
    $(document).off('.a11y021');                   // replaced below

    function swatches(group) {
      return Array.prototype.filter.call(group.children, function (el) {
        return el.classList.contains('color-swatch');
      });
    }
    function sync(group) {
      var list = swatches(group);
      if (!list.length) return;
      setAttr(group, 'role', 'radiogroup');
      var current = null;
      list.forEach(function (el, i) {
        var on = el.classList.contains('active');
        if (on) current = el;
        setAttr(el, 'role', 'radio');
        setAttr(el, 'aria-checked', on ? 'true' : 'false');
        rmAttr(el, 'aria-pressed');
        setAttr(el, 'aria-posinset', i + 1);
        setAttr(el, 'aria-setsize', list.length);
      });
      var stop = current || (list.indexOf(document.activeElement) > -1 ? document.activeElement : list[0]);
      list.forEach(function (el) { setAttr(el, 'tabindex', el === stop ? '0' : '-1'); });
    }
    function syncAll() {
      var groups = document.querySelectorAll('.grid-product__colors');
      for (var i = 0; i < groups.length; i++) sync(groups[i]);
    }
    function choose(el) {
      if (!el.classList.contains('active')) el.click();   // runs the theme's onclick (image swap)
      var g = el.parentNode;
      setTimeout(function () { sync(g); }, 0);
    }

    document.addEventListener('keydown', function (e) {
      var el = e.target;
      if (!el || !el.classList || !el.classList.contains('color-swatch') ||
          !el.parentNode || !el.parentNode.classList.contains('grid-product__colors')) return;
      var list = swatches(el.parentNode), i = list.indexOf(el), next = null;
      switch (e.key) {
        case 'ArrowRight': case 'ArrowDown': next = list[(i + 1) % list.length]; break;
        case 'ArrowLeft': case 'ArrowUp': next = list[(i - 1 + list.length) % list.length]; break;
        case 'Home': next = list[0]; break;
        case 'End': next = list[list.length - 1]; break;
        case ' ': case 'Spacebar': case 'Enter':
          e.preventDefault(); e.stopImmediatePropagation(); choose(el); return;
        default: return;
      }
      e.preventDefault();
      list.forEach(function (s) { setAttr(s, 'tabindex', s === next ? '0' : '-1'); });
      next.focus();
      choose(next);
    }, true);
    // mouse clicks: keep aria-checked in step with the theme's "active" class
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest && e.target.closest('.grid-product__colors > .color-swatch');
      if (el) setTimeout(function () { sync(el.parentNode); }, 0);
    }, true);

    syncAll();
    var grid = document.querySelector('#CollectionAjaxContent, .collection-grid__wrapper, main') || document.body;
    watch(grid, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }, syncAll, 120);
  })();


  /* =====================================================================
   * v8 – 15-Oct-2026  Product carousels: the slider follows keyboard focus
   * Homepage "Shop" collection switcher (and any Flickity product row).
   * Flickity shows 5 cards per slide and marks the other cards
   * aria-hidden="true". When Tab moved into a card on another slide, the
   * browser scrolled Flickity's overflow:hidden viewport by itself
   * (scrollLeft) but Flickity never changed slide. Result: the focused
   * product link/image could sit off-screen or half-clipped (only the small
   * colour swatches looked focused), the focused card stayed aria-hidden
   * (NVDA said nothing for it), and the Previous/Next arrows went out of
   * step. Now, when focus enters a card, Flickity selects the slide that
   * contains it and the stray native scroll is reset.                    */
  (function () {
    var F = window.Flickity;
    if (!F || !F.data) return;

    function sync(target) {
      var root = target.closest && target.closest('.flickity-enabled');
      if (!root) return;
      var flkty = F.data(root);
      if (!flkty || !flkty.getParentCell) return;
      var cell = flkty.getParentCell(target);
      if (!cell) return;
      var idx = flkty.cells.indexOf(cell);
      var slide = flkty.slides[flkty.selectedIndex];
      var inSlide = slide && slide.cells.indexOf(cell) > -1;
      if (!inSlide) flkty.selectCell(idx, false, true);   // instant, no wrap
      var vp = root.querySelector('.flickity-viewport');
      if (vp && vp.scrollLeft) vp.scrollLeft = 0;         // undo the browser's own scroll
      rmAttr(cell.element, 'aria-hidden');                 // focused card is never hidden
    }

    document.addEventListener('focusin', function (e) {
      if (!e.target.closest || !e.target.closest('.flickity-enabled .flickity-viewport')) return;
      sync(e.target);
      // the browser may scroll again after focus lands
      setTimeout(function () { if (document.activeElement === e.target) sync(e.target); }, 0);
    }, true);

    // A11Y-084: Flickity marks product cards on other slides aria-hidden="true"
    // although their link and swatches stay in the Tab order (axe
    // "aria-hidden-focus"). Every card is reachable and the slider now follows
    // focus, so product cards are never hidden from screen readers.
    function unhide() {
      var hidden = document.querySelectorAll('.flickity-slider > .grid-product[aria-hidden="true"], .flickity-slider > .grid__item[aria-hidden="true"]');
      for (var i = 0; i < hidden.length; i++) hidden[i].removeAttribute('aria-hidden');
    }
    unhide();
    watch(document.body, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] }, unhide, 30);

    // a viewport should never scroll natively; keep it at 0
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('flickity-viewport') && t.scrollLeft) {
        var a = document.activeElement;
        if (a && t.contains(a)) sync(a); else t.scrollLeft = 0;
      }
    }, true);
  })();


  /* =====================================================================
   * v9 – 15-Oct-2026  Star ratings include the average (A11Y-087 / 045)
   * The older add-on labelled Junip ratings from a "data-rating" attribute
   * that Junip does not use, so cards read "Star rating, 232 reviews" with
   * no score. Junip stores it in data-product-rating-average.
   * Result: "Rated 4.98 out of 5 stars, 232 reviews".                    */
  (function () {
    function fix() {
      var els = document.querySelectorAll('[data-abc-stars]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var src = el.closest('[data-product-rating-average]') || el.querySelector('[data-product-rating-average]');
        if (!src) continue;
        var avg = parseFloat(src.getAttribute('data-product-rating-average'));
        var cnt = src.getAttribute('data-product-rating-count');
        if (!avg) continue;
        var outer = el.parentElement && el.parentElement.closest('[data-abc-stars]');
        if (outer && outer !== el) {           // nested duplicate: keep one label
          rmAttr(el, 'role'); rmAttr(el, 'aria-label');
          continue;
        }
        setAttr(el, 'aria-label', 'Rated ' + (Math.round(avg * 100) / 100) + ' out of 5 stars' +
          (cnt ? ', ' + cnt + ' review' + (cnt === '1' ? '' : 's') : ''));
      }
    }
    fix();
    watch(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-abc-stars', 'data-product-rating-average'] }, fix, 200);
  })();


  /* v10 – header cart button: singular "Cart, 1 item" (theme text says "1 items") */
  (function () {
    function fix() {
      var cs = document.querySelectorAll('[data-cart-count-a11y]');
      for (var i = 0; i < cs.length; i++) {
        var n = cs[i].nextSibling;
        if (!n || n.nodeType !== 3) continue;
        var want = n.nodeValue.replace(/^(\s*)items?\b/, '$1' + (cs[i].textContent.trim() === '1' ? 'item' : 'items'));
        if (want !== n.nodeValue) n.nodeValue = want;
      }
    }
    fix();
    watch(document.body, { childList: true, subtree: true, characterData: true }, fix, 100);
  })();

  /* v11 – A11Y-119: mobile menu expand toggles had no name of their own
   * (aria-labelledby pointed at the neighbouring link, so NVDA read
   * "BELTS button" exactly like the "BELTS" link). Name them
   * "BELTS submenu"; aria-expanded still says collapsed / expanded.   */
  (function () {
    function fix() {
      var bs = document.querySelectorAll('#NavDrawer button.collapsible-trigger[aria-labelledby]');
      for (var i = 0; i < bs.length; i++) {
        var b = bs[i], lab = document.getElementById(b.getAttribute('aria-labelledby'));
        var t = lab ? lab.textContent.replace(/\s+/g, ' ').trim() : '';
        if (!t) continue;
        setAttr(b, 'aria-label', t + ' submenu');
        rmAttr(b, 'aria-labelledby');
      }
    }
    fix();
    watch(document.getElementById('NavDrawer'), { childList: true, subtree: true }, fix, 100);
  })();

  /* v13 – Enter in a personalization text field (Dog name / Line 1 ...) did
   * nothing. ada-pro.js "A11Y-VARIANT-ENTER" cancels Enter on EVERY <input> in
   * the add-to-cart form (meant for the colour radios), so the browser's normal
   * "Enter submits the form" no longer happens for text fields. Here, Enter in a
   * text-type field presses the form's Add to cart button instead - the same
   * path as a mouse click, so required-field errors (v3) and upez still run.
   * Runs on window (capture) so it is ahead of ada-pro's document handler.  */
  (function () {
    var TEXT = /^(text|search|email|tel|url|number|password)$/i;
    window.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.isComposing || e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) return;
      var el = e.target;
      if (!el || el.tagName !== 'INPUT' || !TEXT.test(el.type || 'text')) return;
      var form = el.form;
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (el.closest && el.closest('#upezCartContainer')) return;
      var btn = form.querySelector('[type="submit"]') ||
        (form.id && document.querySelector('[type="submit"][form="' + form.id + '"]'));
      if (!btn || btn.disabled) return;
      e.preventDefault();
      btn.click();
    }, true);
  })();

  if (window.console) console.log('[ABC-RETEST] accessibility add-on loaded (006, 040, 070, 076, 096, 114, Junip, v2 cart, v3 form errors, v4 cart prices + added announcement, v5 swatches, v8 carousel focus + no hidden cards, v9 rating average, v10 cart count, v11 mobile submenu names, v13 Enter in personalization fields)');
  } // end main
})(window.jQuery);